import * as React from "react";

export default () => {
  return <div>Debiteringsspecifik information</div>;
};
